import React from 'react';

const AllNotifications = () => {
  return (
    <div>AllNotifications</div>
  );
};

export default AllNotifications;
